import React from 'react';
import { cnMessageBox } from '../MessageBox';
import './MessageBox-TextWrap.css';
export var MessageBoxTextWrap = function (_a) {
    var className = _a.className, _b = _a.align, align = _b === void 0 ? 'left' : _b, children = _a.children, leading = _a.leading, trailing = _a.trailing;
    return (React.createElement("div", { className: cnMessageBox('TextWrap', { align: align }, [className]) },
        leading && React.createElement("div", { className: cnMessageBox('TextLeft') }, leading),
        children && React.createElement("div", { className: cnMessageBox('Text') }, children),
        trailing && React.createElement("div", { className: cnMessageBox('TextRight') }, trailing)));
};
